import {
  CREATE_SUBSCRIPTION,
  GET_USER_DATA,
  RESET_USER_DATA,
  UPDATE_USER_ERROR,
  USER_LOGOUT,
} from 'actions/actionTypes';
import { IUserState, IUser, ParentUser } from 'types';

type ActionType =
  | { type: 'GET_USER_DATA'; payload: IUser | ParentUser }
  | { type: 'RESET_USER_DATA' }
  | {
      type: 'UPDATE_USER_ERROR';
      payload: string[];
    }
  | { type: 'USER_LOGOUT' }
  | {
      type: typeof CREATE_SUBSCRIPTION;
      payload: ParentUser;
    };

const initialState: IUserState = {
  userData: null,
  errors: [],
};

const user = (state = initialState, action: ActionType): IUserState => {
  switch (action.type) {
    case GET_USER_DATA:
      return {
        ...state,
        userData: { ...(state.userData || {}), ...action.payload },
      };
    case RESET_USER_DATA:
      return initialState;
    case UPDATE_USER_ERROR:
      return {
        ...state,
        errors: action.payload,
      };
    case CREATE_SUBSCRIPTION:
      return {
        ...state,
        userData: action.payload,
      };
    case USER_LOGOUT:
      return {
        ...state,
        userData: null,
      };
    default:
      return state;
  }
};

export default user;
